import AddIcon from '@mui/icons-material/Add';
import { Button, Menu, MenuItem } from '@mui/material';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useState } from 'react';
import { MaggieFeatureFlags } from '../../../util/feature-flags';
import { ColumnFieldModal, CustomFieldModal, KpiFieldModal } from './FieldFormModals';
import { FormulaFieldModal } from './FormulaFieldModal';
import { FIELD_KINDS, FIELD_KIND_CREATE_LABEL, FieldKind } from './fieldManagerModels';

/**
 * The Field Manager's create entry point: a menu of field kinds hanging off the
 * header button (the same shape as Finance's Add menu), each item opening that
 * kind's own create form — the same modals used for editing.
 */
export function FieldCreateMenu() {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const [kind, setKind] = useState<FieldKind | null>(null);
  const { showFormulaFields } = useFlags<MaggieFeatureFlags>();
  const kinds = FIELD_KINDS.filter((k) => k !== 'formula' || showFormulaFields);

  const openForm = (next: FieldKind) => {
    setAnchor(null);
    setKind(next);
  };
  const onClose = () => setKind(null);

  return (
    <>
      <Button
        color='secondary'
        variant='contained'
        startIcon={<AddIcon />}
        onClick={(event) => setAnchor(event.currentTarget)}
      >
        Create
      </Button>
      <Menu
        anchorEl={anchor}
        open={anchor != null}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {kinds.map((k) => (
          <MenuItem key={k} onClick={() => openForm(k)}>
            {FIELD_KIND_CREATE_LABEL[k]}
          </MenuItem>
        ))}
      </Menu>
      {kind === 'kpi' && <KpiFieldModal onClose={onClose} />}
      {kind === 'custom' && <CustomFieldModal onClose={onClose} />}
      {kind === 'column' && <ColumnFieldModal onClose={onClose} />}
      {kind === 'formula' && <FormulaFieldModal onClose={onClose} />}
    </>
  );
}
